import React from 'react';
import { useSelector } from 'react-redux';
import { setSelectedApproaches, setSelectedIssues, setSelectedOrganizationTypes } from '../slice';
import queryContext from './context'

const QueryProvider = ({children}) => {
  const {
    approachesById,
    issuesById,
    organizationTypesById
  } = useSelector(state => state.system);

  const {
    selectedApproaches,
    selectedIssues,
    selectedOrganizationTypes,
  } = useSelector(state => state.search);

  const config = {
    approach: {
      param: "typeApproach",
      setter: setSelectedApproaches,
      map: approachesById,
      selectedValues: selectedApproaches,
    },
    issue: {
      param: "typeIssue",
      setter: setSelectedIssues,
      map: issuesById,
      selectedValues: selectedIssues,
    },
    organizationType: {
      param: "typeOrganisasi",
      setter: setSelectedOrganizationTypes,
      map: organizationTypesById,
      selectedValues: selectedOrganizationTypes,
    },
  };

  return (
    <queryContext.Provider value={{ config }}>
      {children}
    </queryContext.Provider>
  )
}

export default QueryProvider
